import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { ROUTES } from "../../constants/Routes";
import Layout from "../../Layout";

const RequireAuth = ({ allowedRoles }) => {
  const { getAuth } = useAuth();
  const location = useLocation();

  return getAuth()?.userData && getAuth()?.bearerToken ? (
    getAuth().role === allowedRoles ? (
      <Layout />
    ) : (
      <Navigate to={ROUTES.AUTH} state={{ from: location }} replace />
    )
  ) : (
    <Navigate to={ROUTES.AUTH} state={{ from: location }} replace />
  );
};

export default RequireAuth;
